module.exports = function (bootstrap) {

    bootstrap.directive('favorite', function () {

        return {
            restrict : 'A',
            replace  : false,
            scope    : {
                favorite: "=",
                professionalInfo : "=",
                selectedLocation : "=",
                productId: "=",
                vendorType: "=",
                alphaPrefix: "=",
                coremetricsId: '@?'
            },
            template : '<button data-ng-show="!provider.favorited" data-ng-click="saveFavorite()">' +
                            '<span class="hm-icon icon-add-to-favorites"></span> Add to favorites' +
                        '</button>' +
                        '<button data-ng-show="provider.favorited" data-ng-click="removeFavorite()">' +
                            '<span class="hm-icon icon-remove-from-favorites"></span> Remove from favorites'+
                        '</button>',
            controller : ['$scope', '$q', '$state', 'sessionData', 'services', 'coremetrics',

                function ($scope, $q, $state, sessionData, services, coremetrics) {

                    var entityId = function () {

                            if ($scope.professionalInfo && $scope.professionalInfo.practitionerId) {
                                return $scope.professionalInfo.practitionerId;
                            } else if ($scope.professionalInfo && $scope.selectedLocation.vendorId) {
                                return $scope.selectedLocation.vendorId;
                            } else {
                                return 0;
                            }

                        }(),

                        url = '#/details/' + ($scope.professionalInfo.practitionerId || "") +
                            "/" + ($scope.selectedLocation.vendorId || "") +
                            "/" + ($scope.selectedLocation.locationSequenceNo || "") +
                            "/" + ($scope.productId || "") + "?alphaPrefix=" + ($scope.alphaPrefix) + "&vendorType=" + ($scope.vendorType) ;

                    $scope.provider = {
                        favorited: false,
                        favoriteId: 0
                    };

                    $scope.removeFavorite = function () {

                        coremetrics.elementTag($scope.coremetricsId + ':REMOVE FROM FAVORITES', $scope.coremetricsId);

                        if (sessionData.loggedIn) {

                            $scope.provider.favorited = false; //appear to the UI to automatically saved - service takes longer

                            services.rbsmbl.favorites().remove({ favoriteId: $scope.provider.favoriteId }).then(function () {
                                initialize();
                                $scope.$emit('favorites:update');
                            }, function (err) {
                                $scope.provider.favorited = true; //if fails, revert to still favorited
                            });
                        }

                    };

                    $scope.saveFavorite = function () {

                        coremetrics.elementTag($scope.coremetricsId + ':ADD TO FAVORITES', $scope.coremetricsId);

                        if (sessionData.loggedIn) {

                            $scope.provider.favorited = true; //appear to the UI to automatically saved - service takes longer

                            services.rbsmbl.favorites().saveFavorite({
                                typeName: ($scope.professionalInfo.practitionerId) ? "PROVIDER" : "FACILITY",
                                displayName: ($scope.professionalInfo.practitionerId) ? $scope.professionalInfo.displayName : $scope.selectedLocation.displayName,
                                entityId: ($scope.professionalInfo.practitionerId) ? $scope.professionalInfo.practitionerId : $scope.selectedLocation.vendorId,
                                url: url
                            }).then(function () {
                                initialize();
                                $scope.$emit('favorites:update');
                            }, function (err) {
                                $scope.provider.favorited = false; //if failed, revert to not-favorited
                            });
                        }

                    };

                    function getUpdatedFavorites () {

                        var deferred = $q.defer(),
                            parsed = [];

                        if (sessionData.loggedIn) {

                            services.rbsmbl.favorites().fetchAll().then(function (res) {

                                parsed = services.rbsmbl.favorites().parse(res);

                                if (parsed.length > 0) {
                                    deferred.resolve(parsed);
                                } else {
                                    deferred.resolve([]);
                                }

                            }, function () {
                                deferred.reject([]);
                            });
                        }

                        return deferred.promise;

                    }

                    function checkIfFavorited (list, entityId) {

                        if (list.length > 0 && entityId) {

                            for (var i=0;i<list.length;i++) {

                                //if current provider matches a entity that the member has saved
                                if (entityId === list[i].entityId.toString()) {
                                    return {
                                        favorited: true,
                                        favoriteId: list[i].favoriteId
                                    };
                                }
                            }
                        }

                        //only hits this if no matches, or no providers favorited
                        return {
                            favorited: false,
                            favoriteId: 0
                        };

                    }

                    function initialize () {

                        getUpdatedFavorites().then(function (res) {
                            $scope.provider = checkIfFavorited(res, entityId);
                        });

                    }

                    $scope.$watch(function () { return sessionData.loggedIn; }, function (newVal) {
                        if (newVal) {
                            initialize();
                        }
                    });

                    $scope.$on('favorites:updateChildren', function () {
                        initialize();
                    });

                }
            ]
        };
    });
};